// extracted by mini-css-extract-plugin
export default {"sectionHeader":"header_sectionHeader__7tG-F","title":"header_title__U3mNX","line":"header_line__15KQ8"};